<template>
<div id="building">
    <Nav type="transparent" />
    建设中，敬请期待～
</div>
</template>

<script>
import Nav from '@/components/Nav.vue'
export default {
    name: 'Building',
    data (){
        return {

        }
    },
    components: {
        Nav,
    },
    computed: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
    #building {
        height: 90vh;
        font-size: 40px;
        line-height: 90vh;
        text-align: center;
    }
</style>
